export interface Speaker {
    slug: string;
    firstName: string;
    lastName: string;
    headline: string;
    imageAvatar: string;
    imageBackground: string;
    imageCard: string;
    imageCompany?: string;
    company?: string;
    bio: string;
    twitter?: string;
    linkedin?: string;
    facebook?: string;
    hidden?: boolean;
}

const speakers: Speaker[] = [
    {
        slug: 'kunal',
        firstName: 'Kunal',
        lastName: 'Patel',
        imageAvatar: 'avatar-kunal-patel.jpg',
        imageBackground: 'bg-kunal-patel.jpg',
        imageCard: 'card-kunal-patel.jpg',
        imageCompany: 'brand-google.svg',
        headline: 'Senior Interaction Designer',
        company: 'Material Design, Google',
        bio: 'Kunal is a Senior Interaction Designer on the Material Design team at Google, creating design patterns and guidelines for beautiful, usable cross-platform applications. He focuses on accessible design practices, emergent technologies, and design outreach. Kunal holds an MFA in Design & Technology from Parsons The New School for Design and a Bachelor\'s of Architecture from Carnegie Mellon University.',
    },
    {
        slug: 'javier',
        firstName: 'Javier',
        lastName: 'Lopez',
        imageAvatar: 'avatar-javier-lopez.jpg',
        imageBackground: 'bg-javier-lopez.jpg',
        imageCard: 'card-javier-lopez.jpg',
        imageCompany: 'brand-google.svg',
        headline: 'Designer',
        company: 'Material Design, Google',
        bio: 'Javier is a Designer working on the Material Design team creating visual and interaction systems for beautiful, usable multi-platform applications. His work is centered on the intuitive application of color and educating teams on how to use the Material Design system. Javier received an MFA in Graphic Design from the Maryland Institute College of Art, and BFA in Visual Communication from the School of the Art Institute of Chicago. ',
        linkedin: 'javierlopez8',
        twitter: 'javierlopez288',
    },
    {
        slug: 'angela',
        firstName: 'Angela',
        lastName: 'Guzman',
        imageAvatar: 'avatar-angela-guzman.jpg',
        imageBackground: 'bg-angela-guzman.jpg',
        imageCard: 'card-angela-guzman.jpg',
        // imageCompany: 'brand-google.svg',
        headline: 'UX designer and founder, previously designing experiences',
        company: 'Google',
        bio: 'Angela Guzman is an award-winning UX design lead and entrepreneur based out of Silicon Valley. Over the last decade, she has worked for Google, Airbnb, and Apple. She has managed, led, and directly contributed to design teams that focus on user experience, interaction, and visual design and has numerous design patents to her name. She studied Industrial and Graphic Design from 2002–2009 at the Rhode Island School of Design where she received a BFA and MFA. Angela has also been featured in a number of national and international publications as well as news outlets. Currently, she is developing her own ideas into products for her latest startup. When not designing, she loves to write about design matters, share her experience in the industry as a guest lecturer, and mentor budding designers.',
        linkedin: 'agzmn',
        twitter: 'agzmn',
    },
    {
        slug: 'lindsey',
        firstName: 'Lindsey',
        lastName: 'Wallace',
        imageAvatar: 'avatar-lindsey-wallace.jpg',
        imageBackground: 'bg-lindsey-wallace.jpg',
        imageCard: 'card-lindsey-wallace.jpg',
        imageCompany: 'brand-adobe.svg',
        headline: 'Senior Experience Researcher',
        company: 'Adobe Design',
        bio: 'I bring knowledge about creative professionals\' practices, needs, and motivations to our Adobe design and product teams. As an anthropologist and systems thinker, I use my observation skills and experience understanding individuals in their broader contexts to explain user problems and provide insights into the cultures and values that shape users\' interactions and experiences.',
        linkedin: 'lindseymwallace/',
        twitter: 'LindseyWWallace',
    },
    {
        slug: 'jason',
        firstName: 'Jason',
        lastName: 'van der Merwe',
        imageAvatar: 'avatar-jason-merwe.jpg',
        imageBackground: 'bg-jason-merwe.jpg',
        imageCard: 'card-jason-merwe.jpg',
        imageCompany: 'brand-strava.svg',
        headline: 'Engineering manager',
        company: 'Strava',
        bio: 'Born in South Africa but transplanted to Tennessee, Jason has three passports and an ambiguous ' +
            'accent. Now living in San Francisco, he is an engineering manager at Strava, leading a team that ' +
            'focuses on the early stages of the new user lifecycle. Outside of work, Jason loves to cook and has ' +
            'aspirations of opening a restaurant some day.',
        linkedin: 'jason-van-der-merwe-28699332',
        twitter: 'Jasonvdmerwe',
    },

    {
        slug: 'eli',
        firstName: 'Eli',
        lastName: 'Ganim',
        imageAvatar: 'avatar-eli-ganim.jpg',
        imageBackground: 'bg-eli-ganim.jpg',
        imageCard: 'card-eli-ganim.jpg',
        imageCompany: 'brand-facebook.svg',
        headline: 'iOS Engineer',
        company: 'Facebook',
        bio: 'Eli is an iOS Engineer in Facebook Tel Aviv. He discovered the mobile world in 2010 and never looked back. Since then he has taught numerous mobile development courses, created Facebook\'s iOS bootcamp and co-authored the book Swift Apprentice. Most recently Eli has been focusing on delivering the best possible experience for emerging markets.',
        linkedin: 'eli-ganim-b1901825//',
    },
    {
        slug: 'clemens',
        firstName: 'Clemens',
        lastName: 'Morris',
        imageAvatar: 'avatar-clemens-morris.jpg',
        imageBackground: 'bg-clemens-morris.jpg',
        imageCard: 'card-clemens-morris.jpg',
        imageCompany: 'brand-n26.svg',
        headline: 'Product Designer',
        company: 'N26',
        bio: 'Clemens is a Product Designer and is currently working on N26\'s Design System. Having studied computer science for 2 years while falling in love with product design along the way, Clemens discovered that design systems are the perfect harmony between both disciplines. He loves amazing food, playing the drums and endlessly scrolling through Instagram.',
    },
    {
        slug: 'omkar',
        firstName: 'Omkar',
        lastName: 'Pimple',
        imageAvatar: 'avatar-omkar-pimple.jpg',
        imageBackground: 'bg-omkar-pimple.jpg',
        imageCard: 'card-omkar-pimple.jpg',
        imageCompany: 'brand-n26.svg',
        headline: 'Mobile Core Engineering',
        company: 'N26',
        bio: 'Omkar is a software engineer currently working at N26 GmbH, where he focuses on mentoring, building mobile architecture, design systems and engineering processes that perform at scale. He also works on several active Android side projects that have reached over 5 million users across 180+ countries.',
        linkedin: 'omkarpimple',
    },
    {
        slug: 'mattheweng',
        firstName: 'Matthew',
        lastName: 'Eng',
        imageAvatar: 'avatar-matthew-eng.jpg',
        imageBackground: 'bg-matthew-eng.jpg',
        imageCard: 'card-matthew-eng.jpg',
        imageCompany: 'brand-ibm.svg',
        headline: 'Team Lead',
        company: 'IBM Public Cloud',
        bio: 'Matt is a Research Team Lead for IBM Design. He has worked on projects for companies such as IBM, AT&T, Ogilvy, and Symantec. During these projects, he has conducted numerous design and research efforts that helped to align and focus stakeholders with diverse needs. His experience as a Team Lead for the IBM, led him to discover new techniques for bringing together multidisciplinary teams and internal stakeholders into the research process for quicker alignment. On the side, he runs experiments with bicycles, old computers, and his dog.',
        linkedin: 'mattheweng',
        twitter: 'engmatthew',
    },
    {
        slug: 'karolina',
        firstName: 'Karolina',
        lastName: 'Miekina',
        imageAvatar: 'avatar-karolina-miekina.jpg',
        imageBackground: 'bg-karolina-miekina.jpg',
        imageCard: 'card-karolina-miekina.jpg',
        imageCompany: 'brand-microsoft.svg',
        headline: 'Senior Design Lead',
        company: 'Microsoft',
        bio: 'Kara Miekina is a Senior Design Lead and UX designer focused on the application of emergent technologies to daily productive use. Currently is she at Microsoft Mixed Reality at Work Experiences HQ, where she is unblocking first line workers through the lens of AR/VR. Former Design Lead at IBM Watson Consumer IoT.',
        linkedin: 'karamiekina',
        twitter: 'kina_miekina',
    },
    {
        slug: 'roy',
        firstName: 'Roy',
        lastName: 'Marmelstein',
        imageAvatar: 'avatar-roy-marmelstein.jpg',
        imageBackground: 'bg-roy-marmelstein.jpg',
        imageCard: 'card-roy-marmelstein.jpg',
        imageCompany: 'brand-spotify.svg',
        headline: 'iOS Engineer',
        company: 'Spotify',
        bio: 'Roy is an iOS Engineer at Spotify where he is currently working on UX, architecture and Spotify\'s design platform. He is the creator of PhoneNumberKit, Zip and Interpolate.',
        linkedin: 'roy-marmelstein-2ba36527',
        twitter: 'marmelroy',
    },
    {
        slug: 'maria',
        firstName: 'Maria',
        lastName: 'Neumayer',
        imageAvatar: 'avatar-maria-neumayer.jpg',
        imageBackground: 'bg-maria-neumayer.jpg',
        imageCard: 'card-maria-neumayer.jpg',
        imageCompany: 'brand-deliveroo.svg',
        headline: 'Android Engineer',
        company: 'Deliveroo',
        bio: 'Maria Neumayer is an Android Developer working at Deliveroo. She\'s been developing for Android since 2010 with a focus on UI work. She\'s an Austrian expat living in London, previously worked at various startups including Citymapper and Path.',
        twitter: 'marianeum',
    },
    {
        slug: 'shem',
        firstName: 'Shem',
        lastName: 'Magnezi',
        imageAvatar: 'avatar-shem-magnezi.jpg',
        imageBackground: 'bg-shem-magnezi.jpg',
        imageCard: 'card-shem-magnezi.jpg',
        imageCompany: 'brand-wework.svg',
        headline: 'Staff Software Engineer',
        company: 'WeWork',
        bio: 'Shem has a decade of experience in developing in various domains: client and server side, real-time systems, Big Data, mobile, and web. After a couple of years developing mobile apps, in the last 2 years, he\'s been trying to figure out what it means to be a web developer. Currently, Shem is a staff engineer at WeWork, previously he was the first employee in MyRoll (acquired by AVG).',
        linkedin: 'shem-magnezi-45490424/',
        twitter: 'shemag8',
    },
    // {
    //     slug: 'kurt',
    //     firstName: 'Kurt',
    //     lastName: 'Kemple',
    //     imageAvatar: 'avatar-kurt-kemple.jpg',
    //     imageBackground: 'bg-kurt-kemple.jpg',
    //     imageCard: 'card-kurt-kemple.jpg',
    //     imageCompany: 'brand-amazon.svg',
    //     headline: 'Senior Developer Advocate',
    //     company: 'AWS Mobile',
    //     bio: 'Web / Mobile / GraphQL / Serverless enthusiast • Can be found longboarding in Virginia Beach 🏖',
    //     twitter: 'kurtiskemple',
    // },
    {
        slug: 'luky',
        firstName: 'Luky',
        lastName: 'Primadani',
        imageAvatar: 'avatar-luky-primadani.jpg',
        imageBackground: 'bg-luky-primadani.jpg',
        imageCard: 'card-luky-primadani.jpg',
        imageCompany: 'brand-flixbus.svg',
        headline: 'UX Researcher & Strategist',
        company: 'Flixbus',
        bio: 'Luky, who was formerly a visual designer, has nearly 9 years of career experience in various industries; from advertising & graphic design agency to tech companies. She started her digital career right after she moved to Berlin in 2014 and joined some tech startups ranging from car marketplace to SaaS. Currently, she\'s in the pursuit of her passion in the mobility business with FlixBus and decided to shift her focus from visual design into UX design and user research. Within the course of 1,5 year, she has succeeded in establishing user research and user-centric design process in FlixBus. She likes to challenge the status quo of an organization towards user-centricity and integrate this mindset to create impact within the product development teams and processes. ',
        linkedin: 'luky-primadani-8b216a25',
        twitter: 'lukyprimadani',
        facebook: 'luky.primadani',
    },
    {
        slug: 'wiebe',
        firstName: 'Wiebe',
        lastName: 'Elsinga',
        imageAvatar: 'avatar-wiebe-elsinga.jpg',
        imageBackground: 'bg-wiebe-elsinga.jpg',
        imageCard: 'card-wiebe-elsinga.jpg',
        imageCompany: 'brand-egeniq.svg',
        headline: 'Lead Developer & GDE',
        company: 'Egeniq',
        bio: 'Besides being a GDE (Google Developer Expert) for Android and GDE Product Strategy, Wiebe Elsinga is a Lead Developer at Egeniq in The Netherlands. \n\nHe has a passion for UX and design. He regularly speaks at Mobile Developer conferences or is giving workshops.',
        twitter: 'welsinga',
        facebook: 'welsinga',
    },
    {
        slug: 'gopal',
        firstName: 'Gopal',
        lastName: 'Sharma',
        imageAvatar: 'avatar-gopal-sharma.jpg',
        imageBackground: 'bg-gopal-sharma.jpg',
        imageCard: 'card-gopal-sharma.jpg',
        imageCompany: 'brand-surya.svg',
        headline: 'CTO',
        company: 'Surya Digital',
        bio: 'Gopal is the CTO of Surya Digital, an engineering studio dedicated to build ing great software. He leads teams of iOS, Android, and Server developers. He’s passionate about building teams that build scalable and robust software. Prior to joining Surya, he was a software engineer at Apple. Born in Bangalore 🇮🇳, Gopal is a 4th generation engineer, and coffee enthusiast. When he’s not working, Gopal enjoys playing with his dogs, traveling, and photography.',
        linkedin: 'gopal-sharma-b36273128',
        twitter: 'gopalkri',
    },
    {
        slug: 'dan',
        firstName: 'Dan',
        lastName: 'Abdinoor',
        imageAvatar: 'avatar-dan-abdinoor.jpg',
        imageBackground: 'bg-dan-abdinoor.jpg',
        imageCard: 'card-dan-abdinoor.jpg',
        imageCompany: 'brand-fritz.svg',
        headline: 'CEO and co-founder',
        company: 'Fritz',
        bio: 'Dan Abdinoor is CTO and Cofounder of Fritz, the mobile AI platform that enables developers to teach their applications how to see, hear, sense, and think. Dan has more than a decade of experience leading teams at HubSpot, BabbaCo, Wyth, and Jana Mobile. He has also has mentored dozens of companies in the TechStars accelerator program, serving since 2014.',
        linkedin: 'abdinoor',
        twitter: 'abdinoor',
    },
    {
        slug: 'ana',
        firstName: 'Ana',
        lastName: 'Oarga',
        imageAvatar: 'avatar-ana-oarga.jpg',
        imageBackground: 'bg-ana-oarga.jpg',
        imageCard: 'card-ana-oarga.jpg',
        imageCompany: 'brand-justmad.svg',
        headline: 'Co-founder & Product Strategy',
        company: 'Just Mad',
        bio: 'Ana is all about creativity, diversity, innovative ideas and striking, bright colours. After 5 years of working in the tech field across corporate, agency, and start-up environments for both B2B and B2C businesses, she has gathered extensive knowledge at the intersection of design, product development and business. Great with numbers and people, Ana believes that value is measured in revenue, conversions and happy users. As a certified UX specialist and Design Sprint facilitator, Ana helps companies deliver tangible results for their customers and bring digital products to market and beyond.',
        linkedin: 'ana-nicoleta-oarga',
        twitter: 'ana_oarga',
        facebook: 'ananicoleta.oarga',
    },
    {
        slug: 'raz',
        firstName: 'Raz',
        lastName: 'Burciu',
        imageAvatar: 'avatar-raz-burciu.jpg',
        imageBackground: 'bg-raz-burciu.jpg',
        imageCard: 'card-raz-burciu.jpg',
        imageCompany: 'brand-justmad.svg',
        headline: 'Co-founder & Product Designer',
        company: 'Just Mad',
        bio: 'Raz\'s mindset revolves around the phrase "What if?". With over 7 years of experience in the product design field, his work resides at the crossroads of business, creative direction and innovation. He believes that the worst place to be stuck in is your own comfort zone. As a certified UX specialist and Design Sprint facilitator, he helps forward thinking businesses accelerate the innovation process, deliver value and grow.',
        linkedin: 'razburciu',
        twitter: 'razburciu',
        facebook: 'burciu.razvan.3',
    },
    // {
    //     slug: 'stella',
    //     firstName: 'Stella',
    //     lastName: 'Guan',
    //     imageAvatar: 'avatar-stella-guan.jpg',
    //     imageBackground: 'bg-stella-guan.jpg',
    //     imageCard: 'card-stella-guan.jpg',
    //     imageCompany: 'brand-path-unbound.svg',
    //     headline: 'Award-winning Designer and Founder',
    //     company: 'Path Unbound',
    //     bio: 'Stella Guan is an award-winning visual designer and founder with experience spanning across multiple disciplines and industries. Started her career in broadcast design, Stella has been pushing the boundaries between the specialist and generalist role with her diverse experience in creating effective visual solutions for marketing agencies, advertising agencies, technology companies and global financial services firms such as JPMorgan Chase. In 2019, Stella founded Path Unbound, a company that provides international artists with career advancement and immigration resources.  \n\nStella is a winner of the A\' Design Award, American Web Design Award, CSS Design Awards, Summit Creative Awards, Davey Award and W3 Award. \n\nStella is a member of the Academy of Interactive & Visual Arts and the International Association of Designers. She also served as a judge for the A\' Design Award, CSS Design Awards, Communicator Awards, W3 Award, Davey Award, Creativity International Awards, MediaPost OMMA Awards, the Stevie Award and the Folio: Eddie & Ozzie Awards.',
    //     linkedin: 'stellaguan',
    //     twitter: 'stellaguan',
    // },
    {
        slug: 'jorge',
        firstName: 'Jorge',
        lastName: 'Ortiz-Fuentes',
        imageAvatar: 'avatar-jorge-ortiz-fuentes.jpg',
        imageBackground: 'bg-jorge-ortiz-fuentes.jpg',
        imageCard: 'card-jorge-ortiz-fuentes.jpg',
        imageCompany: 'brand-canonical-examples.svg',
        headline: 'Consultant & instructor for mobile dev best practices',
        company: 'Canonical Examples',
        bio: 'Jorge is a freelancer dedicated to mobile development, security, and systems architecture. He is passionate about things with a chip inside and a believer in voice user interfaces. Proud husband and dad of 3 lovely girls. Loves traveling, talking, reading, watching movies, and trying good food.',
        linkedin: 'jorgeortiz',
        twitter: 'jdortiz',
    },
    {
        slug: 'daniel',
        firstName: 'Daniel',
        lastName: 'Steinberg',
        imageAvatar: 'avatar-daniel-steinberg.jpg',
        imageBackground: 'bg-daniel-steinberg.jpg',
        imageCard: 'card-daniel-steinberg.jpg',
        imageCompany: 'brand-dimsumthinking.svg',
        headline: 'Storyteller',
        company: 'Dim Sum Thinking',
        bio: 'Daniel loves to write about, teach, and code for Apple platforms using Swift. He spends his spare time baking bread, recording and editing podcasts, and hanging out with friends. Lately, he\'s been spending a lot of time with monads - it hasn\'t been pretty.',
        linkedin: 'dimsumthinking',
        twitter: 'dimsumthinking',
    },
    {
        slug: 'jeremy',
        firstName: 'Jeremy',
        lastName: 'Pennycook',
        imageAvatar: 'avatar-jeremy-pennycook.jpg',
        imageBackground: 'bg-jeremy-pennycook.jpg',
        imageCard: 'card-jeremy-pennycook.jpg',
        imageCompany: 'brand-addc.svg',
        headline: 'MC',
        company: 'ADDC',
        bio: 'Jeremy has spent almost a decade building products for your ears. He\'s passionate about the future of audio and voice, both for music and spoken word. He is currently working on podcasts at Spotify. Previously he worked at The Guardian, SoundCloud, and NPR. An avid musician and podcast producer himself, Jeremy is always looking for good recommendations for his next listen.',
        linkedin: 'jeremypennycook',
        twitter: 'jypyk',
    },
];

export const getSpeakerBySlug: (slug: string) => Speaker|undefined = (slug) => {
    return speakers.filter((speaker) => speaker.slug === slug)[0];
};

export const getNextSpeakerAfter: (currentSpeaker: Speaker) => Speaker = (currentSpeaker) => {
    const index = speakers.indexOf(currentSpeaker);

    if (index === speakers.length - 1) {
        return speakers[0];
    }
    return speakers[index + 1];
};

export const getPreviousSpeakerBefore: (currentSpeaker: Speaker) => Speaker = (currentSpeaker) => {
    const index = speakers.indexOf(currentSpeaker);

    if (index === 0) {
        return speakers[speakers.length - 1];
    }
    return speakers[index - 1];
};

export default speakers;
